<template>
  <div>
    <!--<div class="bannerBox">-->
    <Bannerbag />
    <!--<img :src="bannerimg" alt="">-->
    <!--</div>-->
    <!--<div style="background-color: #fff;">-->
    <!--<div class="w1200 firstcolumn_tip">-->
    <!--&lt;!&ndash;<img :src="tipsimg1" alt="">&ndash;&gt;-->
    <!--头条报道-->
    <!--</div>-->
    <!--</div>-->
    <!--<HotClum :list="homeIinitData.firstFiveContent" class="phoneNone" />-->
    <!--<div class="firstcolumn_tip w1200">-->
    <!--&lt;!&ndash;<img :src="tipsimg2" alt="">&ndash;&gt;-->
    <!--最新资讯-->
    <!--</div>-->
    <!--<PengJp />-->
    <div class="w1200 bgc">
      <!--<div class="firstcolumn_tip">-->
      <!--<img :src="tipsimg4" alt="">-->
      <!--</div>-->
      <!--<Citypeng :hotdata="homeIinitData.hotSpecial" />-->
      <!--谱书-->
      <!--<div class="firstcolumn_tip">-->
      <!--&lt;!&ndash;<img :src="pushu" alt="">&ndash;&gt;-->
      <!--国谱馆-->
      <!--</div>-->
      <!--<div class="titlebox">-->
      <!--<span class="titlename">在线家谱</span>-->
      <!--<a href="http://www.myfamilybook.cn/" target="_blank">立即创建我的家谱>></a>-->
      <!--</div>-->
      <!--<div class="banerBox">-->
        <!--<Banner />-->
      <!--</div>-->
      <pushu />
      <Firstcolumn v-if="homeIinitData.firstFiveContent" :columnlist="firstColumn" :initdata="arrData" :alldata="homeIinitData" />
      <!--<hotalbumHome :list="homeIinitData.hotAlbum" />-->
      <!--谱系-->
      <!--<puxi />-->
      <!--谱文-->
      <!--<puwen />-->
      <!--谱人物-->
      <!--<purenwu />-->
      <!--<div class="firstcolumn_tip">-->
      <!--<img :src="tipsimg6" alt="">-->
      <!--</div>-->
      <hotalbumHome :list="homeIinitData.hotAlbum" />
      <hotspecialtopicHome :list="homeIinitData.hotSpecial" />
      <interestedHome :list="interestedHomeData" />
      <!--<div class="firstcolumn_tip">-->
      <!--&lt;!&ndash;<img :src="tipsimg7" alt="">&ndash;&gt;-->
      <!--友情链接-->
      <!--</div>-->
      <!--<div class="bannerlist">-->
      <!--<a v-for="(item,index) in bannerlist" :key="index" target="_blank" :href="item.url" class="bannerlist_list">-->
      <!--<div class="imgBox">-->
      <!--<img :src="item.imgUrl" alt="">-->
      <!--</div>-->
      <!--<p>{{ item.name }}</p>-->
      <!--</a>-->
      <!--</div>-->
    </div>
  </div>
</template>
<script>
import Bannerbag from '@/components/banner'
// 前五张图片
import HotClum from '@/views/components/hotclumHome'
// 首页顶部图片
import Banner from '@/components/banner_smoll/index.vue'
// 首页初始化部分
// 谱书
import pushu from '@/views/firstlist/firstpushu/index.vue'
// 谱系
import puxi from '@/views/firstlist/firstpuxi/index.vue'
// 谱文
import puwen from '@/views/firstlist/firstpuwen/index.vue'
// 人物
import purenwu from '@/views/firstlist/firstpurenwu/index.vue'
import Firstcolumn from '@/views/firstlist/firstcolumn'
import PengJp from '@/components/genealogy_peng/index.vue'
import hotalbumHome from '@/views/components/hotalbumHome'
import interestedHome from '@/views/components/InterestedHome'
import { InterestedHome } from '@/api/api.js'
import Citypeng from '@/components/city_peng/index.vue'
import hotspecialtopicHome from '@/views/components/hotspecialtopicHome/index.vue'
export default {
  components: { Bannerbag, Banner, HotClum, Firstcolumn, PengJp, hotalbumHome, interestedHome, Citypeng, pushu, puxi, puwen, purenwu, hotspecialtopicHome },
  head() {
    // var listObj = this.$store.state.hotList_home
    var metaStr = ''
    // listObj.forEach(a => {
    //   metaStr += a.CONTENT_TITLE + ' | '
    // })
    return {
      title: '首页-彭祖世家网Pengzushijia.com',
      mateDesc: '《彭祖世家总谱-事典》门户网站Pengzushijia.COM ，系彭祖世家文化发展有限公司与武汉聚脉网络科技有限公司合作，基于聚脉网络旗下国家发明专利技术产品“大谱师-互联网家谱协作编纂平台”进行品牌定制，专属服务全球彭氏族群编纂《彭祖世家总谱-事典》总谱、家族谱、家庭谱的互联网家谱协作编纂平台。',
      keys: '《彭祖世家总谱-事典》门户网站Pengzushijia.COM ，彭祖,彭城,彭氏,彭姓,彭氏家谱,彭氏宗谱,彭氏族谱,彭祖世家,彭氏修谱,门户网站'
    }
  },
  data() {
    return {
      topbgc1: {
        backgroundImage: 'url(' + require('@/static/topbgc1.png') + ')'
      },
      topbgc2: {
        backgroundImage: 'url(' + require('@/static/topbgc2.png') + ')'
      },
      topbgc3: {
        backgroundImage: 'url(' + require('@/static/topbgc3.png') + ')'
      },
      arrData: [],
      interestedHomeData: [],
      bannerimg: require('@/static/banner.png'),
      bannerlist: [
        { imgUrl: require('@/static/foot_banner1.png'), name: '国家图书馆', url: 'http://www.nlc.cn/' },
        { imgUrl: require('@/static/foot_banner2.png'), name: '上海图书馆', url: 'http://www.library.sh.cn/jump/' },
        { imgUrl: require('@/static/foot_banner3.png'), name: '中根网', url: 'http://e.chinagen.cn/' },
        { imgUrl: require('@/static/foot_banner4.png'), name: '中国姓氏大百科', url: 'http://ecs.chinagen.cn/login?redirect=%2Fconsole%2Findex' },
        { imgUrl: require('@/static/foot_banner5.png'), name: '中国大百科全书出版社', url: 'http://www.ecph.com.cn/' },
        { imgUrl: require('@/static/foot_banner6.png'), name: '中国家谱知识服务平台', url: 'http://jiapu.library.sh.cn/#/' },
        { imgUrl: require('@/static/foot_banner7.png'), name: '云氏宗亲网', url: 'http://www.yunshiweb.com/' },
        { imgUrl: require('@/static/foot_banner8.png'), name: '钟氏宗亲网', url: 'http://www.zhonghome.com/' },
        { imgUrl: require('@/static/foot_banner9.png'), name: '孔孟之乡', url: 'http://www.kmzx.org/index.html' },
        { imgUrl: require('@/static/foot_banner10.png'), name: '国际儒学', url: 'http://www.ica.org.cn/' }

      ],
      tipsimg1: require('@/static/toutiao_peng.png'),
      tipsimg2: require('@/static/zixun_peng.png'),
      tipsimg4: require('@/static/zhunji_peng.png'),
      tipsimg6: require('@/static/tuijian_peng.png'),
      tipsimg7: require('@/static/youqing_peng.png')
    }
  },
  computed: {
    // 首页初始化数据
    homeIinitData() {
      return this.$store.state.homeData
    },
    // 一级栏目
    firstColumn() {
      if (this.$store.state.homeData.firstLeverColumn.length > 0) {
        var arrs = this.$store.state.homeData.firstLeverColumn
        if (arrs[0].COLUMN_ID !== '1') {
          arrs.unshift({ 'COLUMN_ID': '1', 'COLUMN_NAME': '最新资讯' })
        }
        return arrs
      } else {
        return []
      }
    }
  },

  asyncData({ store, route }) {
    return store.dispatch('getHomeInitData')
  },
  mounted() {
    if (this.homeIinitData.allContent) {
      this.arrData = this.homeIinitData.allContent.listMapData
    } else {
      this.arrData = []
    }
    this.fn()
  },
  created() {
    InterestedHome().then(res => {
      this.interestedHomeData = res.data
    })
  },
  methods: {
    fn: function() {
      window.scrollTo(0, 0)
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  .banerBox{
    display: none;
  }
  .titlebox{
    line-height: 40px;
    background-color: #fff;
    height: 40px;
    margin: 20px 0;
    .titlename{
      display: inline-block;
      height: 20px;
      line-height: 20px;
      border-left: 2px solid #ed4040;
      padding-left: 10px;
      font-size: 18px;
      margin-left: 20px;
      font-weight: 600;
    }
    a{
      float: right;
      font-size: 16px;
      color: #ed4040;
    }
  }
  .bgc{
    background-color: #FAFAFA;
  }
    .bannerBox{
    width: 100%;
    overflow: hidden;
      margin-top: -5px;
    img{
      height: 500px;
      width: 100%;
    }
  }
  /*.topshow{*/
    /*overflow: hidden;*/
    /*margin-top: 20px;*/
    /*text-align: center;*/
      /*.lis{*/
        /*display: inline-block;*/
        /*width: 400px;*/
        /*background-color: #7e6b5a;*/
        /*height: 240px;*/
        /*padding-top: 45px;*/
        /*p{*/
          /*text-align: center;*/
          /*color: #ffffff;*/
          /*margin-bottom: 20px;*/
          /*font-size: 21px;*/
        /*}*/
        /*a{*/
          /*display: inline-block;*/
          /*width: 160px;*/
          /*height: 40px;*/
          /*background-color: #584b3f;*/
          /*line-height: 40px;*/
          /*color: #c3a14f;*/
          /*margin-top: 35px;*/
          /*cursor: pointer;*/
          /*&:hover{*/
            /*color: #ed4040;*/
          /*}*/
        /*}*/
      /*}*/
    /*.lis2{*/
      /*background-color: #847262;*/
    /*}*/
  /*}*/
  .topshow{
    overflow: hidden;
    margin-top: 40px;
    text-align: center;
    vertical-align: top;
    .lis{
      display: inline-block;
      width: 400px;
      height: 195px;
      padding-top: 45px;
      p{
        text-align: center;
        color: #ffffff;
        margin-bottom: 20px;
        font-size: 21px;
      }
      span{
        display: inline-block;
        width: 160px;
        height: 40px;
        background-color: #584b3f;
        line-height: 40px;
        color: #c3a14f;
        margin-top: 35px;
        cursor: pointer;
        &:hover{
          color: #ffffff;
          background: #c3a14f;
        }
      }
    }
  }
  .firstcolumn_tip{
    margin-top: 20px;
    height: 68px;
    border: 1px solid #f0f0f0;
    text-align: center;
    line-height: 68px;
    background-color: #fff;
    font-size: 24px;
    color: #353535;
    font-weight: 600;
    img{
      width: 272px;
      height: 29px;
      margin-top: 20px;
    }
  }
  .bannerlist{
    width: 1200px;
    overflow: hidden;
    margin-top: 20px;
    padding-bottom: 20px;
    margin-bottom: 50px;
    .bannerlist_list{
      background-color: #fff;
      width: 218px;
      height: 98px;
      border: 1px solid #eaeaea;
      margin-top: 20px;
      overflow: hidden;
      font-size: 0;
      text-align: center;
      display: inline-block;
      margin-right: 25px;
      .imgBox{
        width: 100%;
        height: 60px;
        text-align: center;
        cursor: pointer;
        img{
          width: 210px;
          height: 60px;
        }
      }
      p{
        cursor: pointer;
        &:hover{
          color: #ed4040;
        }
      }
    }
    .bannerlist_list:nth-child(5n){
      margin-right: 0;
    }
  }

</style>
<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
  @media screen and (max-width: 750px) {
    .phoneNone{
      display: none;
    }
    .bannerlist{
      width: 100%;
      text-align: center;
      padding-left: 0;
      .bannerlist_list{
        width: 42%;
        margin: 5% 3.5% 0;
        .imgBox{
          img{
            width: 100%;
            height: auto;
          }
        }
      }
    }
    .topshow{
      display: none;
    }
    .banerBox{
      display: block;
      width: 100%;
      height: auto;
    }
  }
</style>
